export default __webpack_public_path__ + "static/media/filter-location-icon.048f7753.svg";